import { render, staticRenderFns } from "./ViewDelegatedRequest.vue?vue&type=template&id=3d3c7848&scoped=true"
import script from "./ViewDelegatedRequest.vue?vue&type=script&lang=js"
export * from "./ViewDelegatedRequest.vue?vue&type=script&lang=js"
import style0 from "./ViewDelegatedRequest.vue?vue&type=style&index=0&id=3d3c7848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3c7848",
  null
  
)

export default component.exports